var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    transform: "translate(-768 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3153",
    "data-name": "Group 3153",
    transform: "translate(0 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "world-svgrepo-com",
    transform: "translate(768 711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M0,0H14V14H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shopicon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M11,4a7,7,0,1,0,7,7A7,7,0,0,0,11,4Zm2.786,6.3a12.526,12.526,0,0,0-.954-4.586A5.608,5.608,0,0,1,16.551,10.3ZM11,16.565c-.425-.334-1.263-2.008-1.384-4.865h2.768C12.263,14.557,11.425,16.231,11,16.565ZM9.616,10.3c.121-2.857.959-4.531,1.384-4.865.425.334,1.263,2.008,1.384,4.865ZM9.168,5.714A12.533,12.533,0,0,0,8.214,10.3H5.449A5.608,5.608,0,0,1,9.168,5.714ZM8.214,11.7a12.526,12.526,0,0,0,.954,4.586A5.608,5.608,0,0,1,5.449,11.7Zm4.618,4.586a12.533,12.533,0,0,0,.954-4.586h2.766A5.609,5.609,0,0,1,12.832,16.286Z",
    transform: "translate(-4 -4)",
    fill: "#949494"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.ee738261b6ae9a6d00555410d32fcd5a.svg";
export { ForwardRef as ReactComponent };